import React, { useEffect, useRef, useState } from 'react';
import { Bot, Loader2, RotateCcw } from 'lucide-react';
import { useAssistente } from './useAssistente';
import { Bolla } from './Bolla';
import { BarraDomanda } from './BarraDomanda';

const ESEMPI = [
  'Posso ricongelare il pesce scongelato?',
  'A che temperatura deve stare il frigo della cucina?',
  'Quali DPI deve usare il lavapiatti?',
  'Cosa faccio se un frigo è fuori temperatura?',
];

const StatoLettura = ({ s }) => {
  if (!s || s.errore) return null;
  return s.in_corso
    ? <p className="text-xs text-gray-600 flex items-center gap-1.5" data-testid="assistente-lettura"><Loader2 className="h-3.5 w-3.5 animate-spin" />Sto leggendo i vostri documenti ({s.documenti}/{s.totali}): intanto puoi già chiedere.</p>
    : <p className="text-xs text-gray-600" data-testid="assistente-letti">Conosco {s.documenti} documenti caricati e i dati dell'app.</p>;
};

export default function AssistenteSection() {
  const a = useAssistente();
  const [ascolto, setAscolto] = useState(false);
  const bloccato = a.occupato || ascolto;
  const fondo = useRef(null);
  const ultimo = a.messaggi[a.messaggi.length - 1];
  useEffect(() => { fondo.current?.scrollIntoView?.({ behavior: 'smooth', block: 'end' }); }, [a.messaggi.length, ultimo?.testo?.length]);
  return (
    <div className="p-4 lg:p-6" data-testid="assistente-section">
      <div className="bg-gray-50 rounded-2xl border border-gray-200 p-3 sm:p-4 space-y-3">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center shrink-0"><Bot className="h-5 w-5 text-white" /></div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-gray-900">Chiedi all'assistente HACCP</p>
            <StatoLettura s={a.stato} />
          </div>
          {a.messaggi.length > 0 && <button onClick={a.nuova} disabled={bloccato} className="h-9 px-3 rounded-full border border-gray-300 bg-white text-xs font-semibold text-gray-700 flex items-center gap-1 disabled:opacity-50" data-testid="assistente-nuova-btn"><RotateCcw className="h-3.5 w-3.5" />Nuova</button>}
        </div>
        {a.messaggi.length === 0 ? (
          <div className="flex flex-wrap gap-2" data-testid="assistente-esempi">
            {ESEMPI.map((e, i) => <button key={e} onClick={() => a.invia(e, null)} disabled={bloccato} className="px-3 py-2 rounded-full bg-white border border-gray-200 text-xs text-gray-800 text-left hover:border-emerald-500 transition-colors disabled:opacity-50" data-testid={`assistente-esempio-${i}`}>{e}</button>)}
          </div>
        ) : (
          <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1" data-testid="assistente-messaggi">
            {a.messaggi.map((m, i) => <Bolla key={m.id} m={m} n={i} />)}
            <div ref={fondo} />
          </div>
        )}
        <BarraDomanda occupato={a.occupato} onInvia={a.invia} onAscolto={setAscolto} />
        <p className="text-[11px] text-gray-500">La conversazione non si salva: sparisce quando chiudi. Risponde dai vostri documenti; nel dubbio chiedi al responsabile.</p>
      </div>
    </div>
  );
}
